@if (drillDownTableResult && flatTableResult) {
    <div class="layoutBlock">
        <div class="columnFull">
            <his-bi-analysis-information
                [report]="report"
                [result]="drillDownTableResult">
            </his-bi-analysis-information>

            <div class="clearAndSpace"></div>

            <his-bi-analysis-action-bar
                [edit]="true"
                [smartTreeTable]="smartTreeTable"
                [report]="report"
                [flatTableResult]="flatTableResult"
                [drillDownTableResult]="drillDownTableResult"
                [headerOrder]="this.drillDownTableResult!.headerOrder"
                [enableReportSharing]="enableReportSharing"
                (headerOrderChanged)="headerOrderChanged($event)"
                (totalColumnChanged)="totalColumnChanged($event)"
                (tableTypeChanged)="switchTable($event)">
            </his-bi-analysis-action-bar>

            <div class="clearAndSpace"></div>

            <p-panel
                [header]="'cs.bia.analysis.result' | hisUi"
                [toggleable]="false"
                [style]="{
                        width: 'fit-content',
                        minWidth: '100%'
                    }">
                <div [hidden]="!showDrillDown">
                  <his-bi-smart-treetable
                    #smartTreetable
                    [result]="drillDownTableResult"
                    [readOnly]="!this.hisAuthService.hasAny( 'RIGHT_CS_BIA_ANALYSIS_CREATE_ANALYSIS')"
                    [headerOrder]="headerOrder"
                    [totalColumn]="totalColumn"
                    (leftDimensionAttributeChange)="onLeftDimensionAttributesReordered($event)">
                  </his-bi-smart-treetable>
                </div>

                @if (!showDrillDown) {
                  <his-bi-flat-table
                    [totalColumn]="totalColumn"
                    [headerOrder]="headerOrder"
                    [result]="flatTableResult"
                    [loading]="false">
                  </his-bi-flat-table>
                }
            </p-panel>

            <div class="clearAndSpace"></div>

            @if (hisAuthService.hasAny("RIGHT_CS_BIA_ANALYSIS_CREATE_ANALYSIS")) {
                <!--
                    Render the result as a tracked single-item collection so Angular destroys
                    and recreates the component whenever the Result instance changes.
                    (The his-display component does not seem to update after its input changes)
                -->
                @if (drillDownTableResult; as result) {
                    @for (item of [result]; track item) {
                        <his-bi-generated-sql [result]="item">
                        </his-bi-generated-sql>
                    }
                }
            }
        </div>
    </div>
}
